(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["show-more"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__ouroShowMore) return;
    window.__ouroShowMore = true;

    document.addEventListener('click', async (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-show-more-link]') : null;
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

      const wrapper = link.closest('[data-show-more]');
      const grid = wrapper?.parentElement?.querySelector('ul.product-grid');
      if (!wrapper || !grid) return;

      event.preventDefault();
      link.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(link.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(String(response.status));
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = doc.querySelector('ul.product-grid');
        const nextControl = doc.querySelector('[data-show-more]');
        if (!nextGrid) throw new Error('No grid');

        const firstNew = nextGrid.firstElementChild;
        grid.append(...Array.from(nextGrid.children).filter((node) => node.tagName === 'LI'));
        if (nextControl) wrapper.replaceWith(document.importNode(nextControl, true));
        else wrapper.remove();

        history.replaceState(history.state, '', link.href);

        const focusTarget = firstNew && document.getElementById(firstNew.id)?.querySelector('a[href]');
        focusTarget?.focus({ preventScroll: true });
      } catch (error) {
        window.location.href = link.href;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
